module.exports = __webpack_public_path__ + "static/media/cbb_app_zh.da6e1844.png";